<template>
    <box-view class="category-module" title="Quản lý Danh mục" :showBack="true" @close="$router.push('/admin')">
        <div class="container-fluid py-3">
            <!-- Header -->
            <div class="row mb-4">
                <div class="col-12 d-flex justify-content-between align-items-center">
                    <h5 class="mb-0 text-secondary">
                        <i class="fas fa-tags mr-2"></i>
                        Tổng: <strong class="text-primary">{{ categories.length }}</strong> danh mục
                    </h5>
                    <button v-if="canManageCategories" class="btn btn-primary btn-add" @click="openModal()">
                        <i class="fas fa-plus mr-2"></i> Thêm danh mục
                    </button>
                </div>
            </div>

            <!-- Category Grid -->
            <div class="row">
                <div v-for="cat in categories" :key="cat.id" class="col-12 col-sm-6 col-md-4 col-lg-3 mb-3">
                    <div class="category-card card border-0 shadow-sm h-100">
                        <div class="card-body p-3 text-center">
                            <div class="category-icon mb-3">
                                <i class="fas fa-tag"></i>
                            </div>
                            <h6 class="mb-2 font-weight-bold">{{ cat.name }}</h6>
                            <small class="text-muted d-block mb-3">{{ cat.id }}</small>
                            <div v-if="canManageCategories" class="d-flex gap-2 justify-content-center">
                                <button class="btn btn-sm btn-outline-primary" @click="openModal(cat)">
                                    <i class="fas fa-edit"></i>
                                </button>
                                <button class="btn btn-sm btn-outline-danger" @click="handleDelete(cat.id)">
                                    <i class="fas fa-trash"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Empty State -->
                <div v-if="categories.length === 0" class="col-12">
                    <div class="empty-state text-center py-5">
                        <i class="fas fa-tags fa-4x text-muted mb-3"></i>
                        <h5 class="text-muted">Chưa có danh mục</h5>
                        <p class="text-muted">Hãy tạo danh mục đầu tiên để phân loại sản phẩm</p>
                    </div>
                </div>
            </div>
        </div>

        <!-- Modal -->
        <van-dialog v-model="showModal" :title="editing ? 'Sửa Danh mục' : 'Thêm Danh mục'" show-cancel-button @confirm="save">
            <div class="p-3">
                <div class="form-group">
                    <label class="font-weight-bold"><i class="fas fa-tag mr-1"></i> Tên danh mục</label>
                    <input type="text" class="form-control" v-model="form.name" placeholder="Nhập tên danh mục">
                </div>
            </div>
        </van-dialog>
    </box-view>
</template>

<script>
export default {
    name: 'Category',
    props: {
        categories: {
            type: Array,
            default: () => []
        },
        user: {
            type: Object,
            default: () => ({})
        },
        settings: {
            type: Object,
            default: () => ({})
        }
    },
    data() {
        return {
            showModal: false,
            editing: false,
            form: {
                id: null,
                name: ''
            }
        };
    },
    computed: {
        canManageCategories() {
            const role = this.user.role || 'admin';
            if(role === 'admin') return true;
            const roleConfig = this.settings.user?.roles?.[role];
            return roleConfig?.permissions?.includes('manageCategories');
        }
    },
    methods: {
        openModal(category = null) {
            if (category) {
                this.editing = true;
                this.form = { ...category };
            } else {
                this.editing = false;
                this.form = {
                    id: null,
                    name: ''
                };
            }
            this.showModal = true;
        },
        save() {
            if (!this.form.name) {
                this.$toast?.('Vui lòng nhập tên');
                return;
            }
            if (this.editing) {
                this.$emit('update-category', this.form);
            } else {
                this.$emit('add-category', this.form);
            }
            this.showModal = false;
        },
        handleDelete(id) {
            if (confirm('Bạn có chắc muốn xóa? Sản phẩm thuộc danh mục này sẽ mất danh mục.')) {
                this.$emit('delete-category', id);
            }
        }
    }
};
</script>

